import React from 'react';
import { postOffboadingTemplateTaskData, updateOffboadingTemplateTaskData } from '../../service/adminApi';
import { directory } from '../../service/PerformanceAPI';
import Select from 'react-select';
import { OnlyNumber, OnlyNumberSpecialChar, OnlySpecialChar } from '../../utils/RegHandling';

function OffboardingTaskForm({ editData, tId, handleData, hideContainer }) {
    let defaultValue = {
        name: '',
        emp_id: '',
        task_id: '',
        duedate_count: '',
        duedate_by: '',
        description: '',
    };
    let errorDefaultValue = {
        nameError: '',
        empIdError: '',
        taskTypeError: '',
        duedateCountError: '',
        duedateByError: '',
        descriptionError: '',
    };

    const [offboardingTaskDetails, setOffboardingTaskDetails] = React.useState(defaultValue);
    const [offboardingTaskDetailsError, setOffboardingTaskDetailsError] = React.useState(errorDefaultValue);
    const [templateId, setTemplateId] = React.useState('');
    const [editId, setEditId] = React.useState();
    const [showNavbar, setShowNavbar] = React.useState(false);
    const [showEmployee, setShowEmployee] = React.useState([]);
    const [selectedPeopleList, setSelectedPeople] = React.useState({});
    const [touchbaseAttendees, settouchbaseAttendees] = React.useState('');
    const [emp, setEmp] = React.useState({});

    React.useEffect(() => {
        if (editData !== undefined) {
            setOffboardingTaskDetails({
                name: editData?.task_name,
                emp_id: editData?.emp_id,
                task_id: editData?.task_id,
                duedate_count: editData?.duedate_count,
                duedate_by: editData?.duedate_by,
                description: editData?.description,
            });
            setSelectedPeople({ value: editData?.emp_id, label: editData?.emp_name });
            setEditId(editData.id);
        }
    }, [editData]);

    React.useEffect(() => {
        if (tId !== undefined) {
            setTemplateId(tId);
        }
    }, [tId]);

    React.useEffect(() => {
        bind();
    }, []);

    const resetData = () => {
        setOffboardingTaskDetails({
            name: '',
            emp_id: '',
            task_id: '',
            duedate_count: '',
            duedate_by: '',
            description: '',
        });
        setOffboardingTaskDetailsError(errorDefaultValue);
        handleData('cancel');
        hideContainer();
    };

    // const handleChange = (e) => {
    //     
    //     // let selectedValue = [];
    //     // let attend = [];
    //     // selectedValue = e;
    //     // e.map((data) => {
    //     //     attend.push(data.value);
    //     // });
    //     setSelectedPeopleList(selectedValue);
    //     setEmp(attend);
    // };

    const bind = async () => {
        let empResult = await directory({});

        let samplearray = [];
        let temparray = empResult.data.ResponseData.emplist;
        for (let i = 0; i <= temparray.length - 1; i++) {
            let objresponse = {
                value: temparray[i].emp_id,
                img: '/Images/logo-person-user-person-icon.jpg',
                label: temparray[i].emp_name,
                username: temparray[i].emp_name,
            };
            samplearray.push(objresponse);
        }
        setShowEmployee(samplearray);
    };

    const handleOffboardingTask = (e) => {
        setOffboardingTaskDetails((offboardingTaskDetails) => ({ ...offboardingTaskDetails, [e.target.name]: e.target.value }));
    };

    const postOffboardingTask = async () => {
        let data = offboardingTaskDetails;
        data['template_id'] = templateId;
        if (validateOffboardingTask() == true) {
            if (editId === undefined || editId === '') {
                const response = await postOffboadingTemplateTaskData(offboardingTaskDetails);
                if (response.data.statusCode === 200) {
                    setOffboardingTaskDetails(defaultValue);
                    handleData('update');
                    hideContainer();
                }
            } else {
                let data = offboardingTaskDetails;
                data['id'] = editId;
                const response = await updateOffboadingTemplateTaskData(offboardingTaskDetails);
                if (response.data.statusCode === 200) {
                    setOffboardingTaskDetails(defaultValue);
                    handleData('update');
                    hideContainer();
                }
            }
        }
    };

    const validateOffboardingTask = () => {
        let result = true;
        if (offboardingTaskDetails.name == '' || offboardingTaskDetails.name == undefined) {
            setOffboardingTaskDetailsError((offboardingTaskDetailsError) => ({
                ...offboardingTaskDetailsError,
                nameError: 'Task Name is required',
            }));
            result = false;
        }
        if (OnlyNumberSpecialChar(offboardingTaskDetails.name)) {
            setOffboardingTaskDetailsError((offboardingTaskDetailsError) => ({
                ...offboardingTaskDetailsError,
                nameError: 'Enter a valid task name',
            }));
            result = false;
        } else if (offboardingTaskDetails.name > 50) {
            setOffboardingTaskDetailsError((offboardingTaskDetailsError) => ({
                ...offboardingTaskDetailsError,
                nameError: 'The task name should be less than 50',
            }));
            result = false;
        }
        if (offboardingTaskDetails.task_id == '' || offboardingTaskDetails.task_id == undefined) {
            setOffboardingTaskDetailsError((offboardingTaskDetailsError) => ({
                ...offboardingTaskDetailsError,
                taskTypeError: 'Task Type is required ',
            }));
            result = false;
        }
        if (offboardingTaskDetails.duedate_by == '' || offboardingTaskDetails.duedate_by == undefined) {
            setOffboardingTaskDetailsError((offboardingTaskDetailsError) => ({
                ...offboardingTaskDetailsError,
                duedateByError: 'This feild is required ',
            }));
            result = false;
        }
        if (offboardingTaskDetails.duedate_count == '' || offboardingTaskDetails.duedate_count == undefined) {
            setOffboardingTaskDetailsError((offboardingTaskDetailsError) => ({
                ...offboardingTaskDetailsError,
                duedateCountError: 'Due Date is required',
            }));
            result = false;
        }
        if (offboardingTaskDetails.emp_id == '' || offboardingTaskDetails.emp_id == undefined) {
            setOffboardingTaskDetailsError((offboardingTaskDetailsError) => ({
                ...offboardingTaskDetailsError,
                empIdError: 'Responsible Person is required',
            }));
            result = false;
        }
        if (offboardingTaskDetails.description == '' || offboardingTaskDetails.description == undefined) {
            setOffboardingTaskDetailsError((offboardingTaskDetailsError) => ({
                ...offboardingTaskDetailsError,
                descriptionError: 'Description is required',
            }));
            result = false;
        }
        return result;
    };

    return (
        <div>
            <>
                <div className="offcanvas-header">
                    <h5 className=" tt-bold font-16 announcement-offcanvas-color">
                        {editData == undefined || editData?.name == undefined ? `New Task` : 'Edit Task'}
                    </h5>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        onClick={() => {
                            resetData();
                        }}
                    />
                </div>
                <div className="offcanvas-body">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12 mb-4">
                                    <label
                                        className="form-label font-12 semibold-text announcement-offcanvas-color"
                                        htmlFor="Announcement-Title"
                                    >
                                        Task Name
                                        <span className="required"> *</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control custom-textfield regular-text font-13"
                                        id="Announcement-Title"
                                        value={offboardingTaskDetails.name}
                                        placeholder="Enter here"
                                        name="name"
                                        onChange={(e) => {
                                            handleOffboardingTask(e);
                                            setOffboardingTaskDetailsError((offboardingTaskDetailsError) => ({
                                                ...offboardingTaskDetailsError,
                                                nameError: '',
                                            }));
                                        }}
                                    />
                                    {offboardingTaskDetailsError.nameError !== undefined || offboardingTaskDetailsError.nameError !== '' ? (
                                        <span className="text-danger font-12 tt-bold">{offboardingTaskDetailsError.nameError}</span>
                                    ) : null}
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-4">
                                        <label
                                            className="form-label font-12 semibold-text announcement-offcanvas-color"
                                            htmlFor="task-type"
                                        >
                                            Task Type
                                            <span className="required"> *</span>
                                        </label>
                                        <select
                                            className="form-select hive-form-select regular-text font-13"
                                            id="task-type"
                                            value={offboardingTaskDetails.task_id}
                                            placeholder="Task Type"
                                            name="task_id"
                                            style={{ height: '39px' }}
                                            onChange={(e) => {
                                                handleOffboardingTask(e);
                                                setOffboardingTaskDetailsError((offboardingTaskDetailsError) => ({
                                                    ...offboardingTaskDetailsError,
                                                    taskTypeError: '',
                                                }));
                                            }}
                                        >
                                            <option value="" selected>
                                                Task Type
                                            </option>
                                            <option value="1">Upload</option>
                                            <option value="2">Checkbox</option>
                                        </select>
                                        {offboardingTaskDetailsError !== undefined || offboardingTaskDetailsError.taskTypeError !== '' ? (
                                            <span className="text-danger font-12 tt-bold">{offboardingTaskDetailsError.taskTypeError}</span>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <label
                                            className="form-label font-12 semibold-text announcement-offcanvas-color"
                                            htmlFor="Announcement-Title"
                                        >
                                            Responsible Person
                                            <span className="required"> *</span>
                                        </label>
                                        <Select
                                            className="dropdown"
                                            name="touchbaseAttendees"
                                            maxMenuHeight={150}
                                            placeholder="Enter here"
                                            value={selectedPeopleList}
                                            options={showEmployee} // set list of the data
                                            onChange={(e) => {
                                                setOffboardingTaskDetailsError((offboardingTaskDetailsError) => ({
                                                    ...offboardingTaskDetailsError,
                                                    empIdError: '',
                                                }));
                                                setSelectedPeople(e);
                                                setOffboardingTaskDetails((offboardingTaskDetails) => ({
                                                    ...offboardingTaskDetails,
                                                    emp_id: e?.value || '',
                                                }));
                                            }} // assign onChange function
                                            isClearable
                                        />
                                        {offboardingTaskDetailsError.empIdError !== undefined ||
                                            offboardingTaskDetailsError.empIdError !== '' ? (
                                            <span className="text-danger font-12 tt-bold">{offboardingTaskDetailsError.empIdError}</span>
                                        ) : null}
                                    </div>
                                </div>

                                <div className="row d-flex align-items-end mb-4">
                                    <div className="col-md-3">
                                        <label
                                            className="form-label font-12 semibold-text announcement-offcanvas-color"
                                            htmlFor="Announcement-Title"
                                        >
                                            Due Date
                                            <span className="required"> *</span>
                                        </label>
                                        <input
                                            value={offboardingTaskDetails.duedate_count}
                                            type="number"
                                            className="form-control custom-textfield regular-text font-13"
                                            id="Announcement-Title"
                                            placeholder="Enter here"
                                            min={0}
                                            name="duedate_count"
                                            onChange={(e) => {
                                                handleOffboardingTask(e);
                                                setOffboardingTaskDetailsError((offboardingTaskDetailsError) => ({
                                                    ...offboardingTaskDetailsError,
                                                    duedateCountError: '',
                                                }));
                                            }}
                                        />
                                        {offboardingTaskDetailsError.duedateCountError !== undefined ||
                                            offboardingTaskDetailsError.duedateCountError !== '' ? (
                                            <span className="text-danger font-12 tt-bold">
                                                {offboardingTaskDetailsError.duedateCountError}
                                            </span>
                                        ) : null}
                                    </div>

                                    <div className="col-md-auto">
                                        <label
                                            className="form-label hive-form-label"
                                            ref={(el) => el && el.style.setProperty('margin-bottom', '15px', 'important')}
                                        >
                                            Day(s)
                                            <span className="hive-form-mandatory" />
                                        </label>
                                    </div>
                                    <div className="col-md-3 mt-4">
                                        <select
                                            name="duedate_by"
                                            onChange={(e) => {
                                                setOffboardingTaskDetailsError((offboardingTaskDetailsError) => ({
                                                    ...offboardingTaskDetailsError,
                                                    duedateByError: '',
                                                }));
                                                handleOffboardingTask(e);
                                            }}
                                            value={offboardingTaskDetails.duedate_by}
                                            className="form-select hive-form-select regular-text custom-textfield mt-2 font-13"
                                            id="e-time"
                                        >
                                            <option value="" selected>
                                                Select
                                            </option>
                                            <option value="before">Before</option>
                                            <option value="after">After</option>
                                        </select>
                                        {offboardingTaskDetailsError.duedateByError !== undefined ||
                                            offboardingTaskDetailsError.duedateByError !== '' ? (
                                            <span className="text-danger font-12 tt-bold">
                                                {offboardingTaskDetailsError.duedateByError}
                                            </span>
                                        ) : null}
                                    </div>
                                    <div className="col-md-3">
                                        <label
                                            className="form-label hive-form-label mb-2"
                                            ref={(el) => el && el.style.setProperty('margin-bottom', '15px', 'important')}
                                        >
                                            Last Working Date<span class="hive-form-mandatory"></span>
                                        </label>
                                    </div>
                                </div>

                                <div className="col-md-12 mb-4">
                                    <label
                                        className="form-label font-12 semibold-text announcement-offcanvas-color"
                                        htmlFor="Announcement-Title"
                                    >
                                        Description
                                        <span className="required"> *</span>
                                    </label>
                                    <textarea
                                        style={{ resize: 'none' }}
                                        value={offboardingTaskDetails.description}
                                        className="form-control custom-textfield regular-text font-13 custom-comment-box"
                                        id="Announcement-Title"
                                        placeholder="Enter here"
                                        name="description"
                                        onChange={(e) => {
                                            setOffboardingTaskDetailsError((offboardingTaskDetailsError) => ({
                                                ...offboardingTaskDetailsError,
                                                descriptionError: '',
                                            }));
                                            handleOffboardingTask(e);
                                        }}
                                    />
                                    {offboardingTaskDetailsError.descriptionError !== undefined ||
                                        offboardingTaskDetailsError.descriptionError !== '' ? (
                                        <span className="text-danger font-12 tt-bold">{offboardingTaskDetailsError.descriptionError}</span>
                                    ) : null}
                                </div>
                            </div>
                            <div className="d-flex justify-content-end mb-4 mt-5 p-0 ">
                                <button
                                    onClick={() => {
                                        resetData();
                                    }}
                                    className="btn hive-btn-secondary me-3"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                >
                                    Cancel
                                </button>

                                <button
                                    style={{ width: '100px' }}
                                    onClick={() => {
                                        postOffboardingTask();
                                    }}
                                    className="btn medium-text font-12 primary-button me-3"
                                    data-bs-dismiss={showNavbar == true ? 'offcanvas' : 'dummy'}
                                    aria-label="Close"
                                >
                                    {editData == undefined || editData?.name == undefined ? `Add` : 'Update'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </div>
    );
}

export default OffboardingTaskForm;
